import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, Loading, dayLabel, timeLabel, useHeaders, usePortal } from './kit';

export const NotificationsPanel = () => {
  const headers = useHeaders();
  const navigate = useNavigate();
  const { closeDrawer } = usePortal();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/notifications?limit=30`, { headers }).then((r) => setRows(r.data.notifications)).catch(() => setRows([]));
    axios.post(`${API}/api/notifications/mark-all-read`, {}, { headers }).catch(() => {});
  }, [headers]);
  if (!rows) return <Loading />;
  if (!rows.length) return <p className="empty" data-testid="notifications-empty">No updates yet. Replies from your team and quote updates appear here.</p>;
  return rows.map((n) => (
    <button key={n.id} className="attention-row" data-testid={`notification-${n.id}`}
      onClick={() => { closeDrawer(); if (/^\/(portal|cleaner)/.test(n.deep_link || '')) navigate(n.deep_link); }}>
      <span className="dot" /><span><strong>{n.title}</strong><small>{n.message} · {dayLabel(n.created_at)} {timeLabel(n.created_at)}</small></span><span className="arrow">↗</span>
    </button>
  ));
};

export default NotificationsPanel;
